import {
  FormControlLabel,
  FormGroup,
  Checkbox,
  Grid,
  TextField,
  Box,
  FormControl,
  MenuItem,
  Button,
  FormHelperText,
  Typography,
  Chip,
} from "@mui/material";
import { React, useRef, useEffect, useState } from "react";

import BluePrimaryButton from "../../common/button/bluePrimaryButton";
import BackButton from "../../common/button/backButton";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers";
import Cookies from "js-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";

import { useDispatch, useSelector } from "react-redux";
import masterFormsActions from "../../redux/masterForms/actions";
import dayjs from "dayjs";

import CreateMasterModal from "../masterForm/modals/createMasterModal";

import eligibilityCriteriaActions from "../../redux/eligibilityCriteria/actions";
export default function AddEligibility() {
  const navigate = useNavigate();
  const location = useLocation();
  let id = location?.state?.id;

  const now = new Date();
  const dispatch = useDispatch();
  const today = new Date();
  const date = new Date();
  const currentYear = date.getFullYear();
  const [years, setYears] = useState([]);

  const { categoryList, pwdtypeList, gspecializationSubjectList } = useSelector(
    (state) => state.masterFormsReducer
  );
  const { eligibilityCriteria } = useSelector(
    (state) => state.eligibilityCriteriaReducer
  );

  const { backofficeTokenDetails } = useSelector((state) => state.authReducer);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    reset,
    trigger,
    control,
    setError,
    resetField,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      criteria_option: "",
      enableNationality: false,
      nationality: "",
      enableMhCandidate: false,
      ismhcandidate: "",
      enableCategory: false,
      categoryid: "",
      enableOrphan: false,
      isorphan: "",
      enableDisability: false,
      disabilitytypeid: "",

      enableHSC: false,
      hscpercentage: "",
      hscyearofpassing: "",
      hscminage: "",
      hscmaxage: "",
      hscason: null,

      enableUG: false,
      ugpercentage: "",
      ugyearofpassing: "",
      ugminage: "",
      ugmaxage: "",
      ugason: null,

      enablePG: false,
      pgpercentage: "",
      pgyearofpassing: "",
      pgminage: "",
      pgmaxage: "",
      pgason: null,
    },
  });

  useEffect(() => {
    if (id && eligibilityCriteria?.length > 0) {
      let data = eligibilityCriteria?.find(
        (obj) => obj.eligibilitycriteriaid == id
      );

      reset({
        ...data,
        criteria_option: data?.criteria_option || "",
        enableNationality: !!data?.nationality,
        nationality: data?.nationality ?? "",
        enableMhCandidate: !!data?.ismhcandidate,
        ismhcandidate: data?.ismhcandidate ?? "",
        enableCategory: !!data?.categoryid,
        categoryid: data?.categoryid ?? "",
        enableOrphan: !!data?.isorphan,
        isorphan: data?.isorphan ?? "",
        enableDisability: !!data?.disabilitytypeid,
        disabilitytypeid: data?.disabilitytypeid ?? "",
        enableHSC:
          !!data?.hscpercentage ||
          !!data?.hscyearofpassing ||
          !!data?.hscminage ||
          !!data?.hscmaxage ||
          !!data?.hscason,
        enableUG:
          !!data?.ugpercentage ||
          data?.ugyearofpassing ||
          data?.ugminage ||
          data?.ugmaxage ||
          data?.ugason ||
          (data?.compulsorysubject && data.compulsorysubject.length > 0),
        enablePG:
          !!data?.pgpercentage ||
          data?.pgyearofpassing ||
          data?.pgminage ||
          data?.pgmaxage ||
          data?.pgason,

        hscason: data.hscason ? dayjs(data.hscason) : null,
        ugason: data.ugason ? dayjs(data.ugason) : null,
        pgason: data.pgason ? dayjs(data.pgason) : null,
        disabilitytypeid:
          data?.disabilitytypeid?.map((i) => i.toString()) || [],
        compulsorysubject:
          data?.compulsorysubject?.map((i) => i.toString()) || [],
        categoryid: data?.categoryid?.map((i) => i.toString()) || [],
      });
    }
  }, [eligibilityCriteria, id, reset]);

  useEffect(() => {
    dispatch({ type: masterFormsActions.GET_NATIONALITY });
    dispatch({ type: masterFormsActions.GET_CATEGORY });
    dispatch({ type: masterFormsActions.GET_PWDTYPE });
    dispatch({ type: masterFormsActions.GET_GSPECIALIZATION_SUBJECT });

    if (location.search === "?page=updateeligibility") {
      dispatch({
        type: eligibilityCriteriaActions.GET_ELIGIBILITY_CRITERIA,
      });
    }

    const getYears = () => {
      const array = [];
      for (let i = 1945; i <= currentYear; i++) {
        array.push(i);
      }
      return array;
    };
    setYears(getYears());
  }, []);

  const resetForm = () => {
    setValue("coursedriveid", "");
    setValue("coursecategoryid", "");

    reset({});
  };

  useEffect(() => {
    if (id) {
      let { prerequisite, ...course } =
        eligibilityCriteria?.all?.find(
          (obj) => obj.eligibilitycriteriaid === id
        ) || {};
    }
  }, [setValue, eligibilityCriteria, id]);

  const handleAddEligibility = (data) => {
    // If criteria_option is Rejection (0), clear all HSC/UG/PG fields
    if (data.criteria_option == 0) {
      data.enableHSC = false;
      data.hscpercentage = null;
      data.hscyearofpassing = null;
      data.hscminage = null;
      data.hscmaxage = null;
      data.hscason = null;

      data.enableUG = false;
      data.ugpercentage = null;
      data.ugyearofpassing = null;
      data.ugminage = null;
      data.ugmaxage = null;
      data.ugason = null;
      data.compulsorysubject = null;

      data.enablePG = false;
      data.pgpercentage = null;
      data.pgyearofpassing = null;
      data.pgminage = null;
      data.pgmaxage = null;
      data.pgason = null;
    }

    data.criteria_option = parseInt(data.criteria_option);
    data.nationality = data.enableNationality
      ? parseInt(data.nationality)
      : null;
    data.ismhcandidate = data.enableMhCandidate
      ? parseInt(data.ismhcandidate)
      : null;
    data.isorphan = data.enableOrphan ? parseInt(data.isorphan) : null;
    data["userid"] = backofficeTokenDetails?.id;

    dispatch({
      type: eligibilityCriteriaActions.CREATE_ELIGIBILITY_CRITERIA,
      payload: { data: data, navigate: navigate, resetForm: resetForm },
    });
  };

  const handleUpdateEligibility = (data) => {
    // If criteria_option is Rejection (0), clear all HSC/UG/PG fields
    if (data.criteria_option == 0) {
      data.enableHSC = false;
      data.hscpercentage = null;
      data.hscyearofpassing = null;
      data.hscminage = null;
      data.hscmaxage = null;
      data.hscason = null;

      data.enableUG = false;
      data.ugpercentage = null;
      data.ugyearofpassing = null;
      data.ugminage = null;
      data.ugmaxage = null;
      data.ugason = null;
      data.compulsorysubject = null;

      data.enablePG = false;
      data.pgpercentage = null;
      data.pgyearofpassing = null;
      data.pgminage = null;
      data.pgmaxage = null;
      data.pgason = null;
    }

    data.criteria_option = parseInt(data.criteria_option);
    data.nationality = data.enableNationality
      ? parseInt(data.nationality)
      : null;
    data.ismhcandidate = data.enableMhCandidate
      ? parseInt(data.ismhcandidate)
      : null;
    data.isorphan = data.enableOrphan ? parseInt(data.isorphan) : null;
    data["userid"] = backofficeTokenDetails?.id;

    dispatch({
      type: eligibilityCriteriaActions.UPDATE_ELIGIBILITY_CRITERIA,
      payload: { data: data, navigate: navigate, resetForm: resetForm },
    });
  };

  // const handleAddEligibility = (data) => {

  //   data.nationality = data.enableNationality ? data.nationality : null;
  // data.ismhcandidate = data.enableMhCandidate ? data.ismhcandidate : null;
  // data.isorphan = data.enableOrphan ? data.isorphan : null;

  //   data["userid"] = backofficeTokenDetails?.id;

  //   dispatch({
  //     type: eligibilityCriteriaActions.CREATE_ELIGIBILITY_CRITERIA,
  //     payload: { data: data, navigate: navigate, resetForm: resetForm },
  //   });
  // };

  // const handleUpdateEligibility = (data) => {
  //   data["userid"] = backofficeTokenDetails?.id;

  //   data.nationality = data.enableNationality ? parseInt(data.nationality ): null;
  // data.ismhcandidate = data.enableMhCandidate ? parseInt(data.ismhcandidate) : null;
  // data.isorphan = data.enableOrphan ? parseInt(data.isorphan) : null;

  //   dispatch({
  //     type: eligibilityCriteriaActions.UPDATE_ELIGIBILITY_CRITERIA,
  //     payload: { data: data, navigate: navigate, resetForm: resetForm },
  //   });
  // };

  const handleChange = (e) => {
    const value = e.target.value;
    const isDuplicate = eligibilityCriteria.some(
      (item) =>
        item.eligibilitycriterianame.toLowerCase() === value.toLowerCase()
    );

    if (isDuplicate) {
      setError("eligibilitycriterianame", {
        type: "manual",
        message: "Eligibility Criteria Name already exists",
      });
    } else {
      clearErrors("eligibilitycriterianame");
    }
  };

  return (
    <>
      <Typography variant="h5" mb={3}>
        Eligibility Criteria Information
      </Typography>

      <Grid container spacing={3} mb={3}>
        <Grid item xs={12} md={8}>
          <TextField
            sx={{ width: "126%", height: "50px" }}
            {...register("eligibilitycriterianame", {
              required: "Eligibility Criteria Name is required",
              onChange: handleChange,
            })}
            InputLabelProps={{
              shrink: !!watch("eligibilitycriterianame"),
            }}
            error={!!errors.eligibilitycriterianame}
            helperText={errors.eligibilitycriterianame?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Eligibility Criteria Name
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
          />
        </Grid>

        <Grid item xs={12} md={10}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <FormControl fullWidth>
              <TextField
                select
                label={
                  <span>
                    Select Criteria Option
                    <span className="error" style={{ color: "red" }}>
                      *
                    </span>
                  </span>
                }
                {...register("criteria_option", {
                  required: "Criteria Option is required",
                })}
                defaultValue={watch("criteria_option") || ""}
                value={watch("criteria_option") ?? ""}
                error={!!errors.criteria_option}
                helperText={errors.criteria_option?.message}
                sx={{ width: "100%", height: "55px" }}
              >
                <MenuItem value="" disabled>
                  Select One
                </MenuItem>
                <MenuItem value={0}>Rejection</MenuItem>
                <MenuItem value={1}>Minimum</MenuItem>
              </TextField>
            </FormControl>
          </Box>
        </Grid>

        <Grid item xs={12} md={10}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={watch("enableNationality")}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    setValue("enableNationality", isChecked);
                    setValue("nationality", isChecked ? "" : null);
                  }}
                />
              }
              label="Enable Nationality Selection"
              sx={{ whiteSpace: "nowrap" }}
            />

            <FormControl
              fullWidth
              error={!!errors.nationality}
              disabled={!watch("enableNationality")}
              sx={{ marginLeft: "4%" }}
            >
              <Controller
                name="nationality"
                control={control}
                rules={{
                  required: watch("enableNationality")
                    ? "Select Nationality required"
                    : false,
                }}
                render={({ field }) => (
                  <TextField
                    select
                    label="Select Nationality"
                    value={field.value ?? ""}
                    onChange={(e) => field.onChange(e.target.value)}
                    disabled={!watch("enableNationality")}
                    sx={{ width: "100%", height: "55px" }}
                  >
                    <MenuItem value="" disabled>
                      Select One
                    </MenuItem>
                    <MenuItem value={1}>Indian</MenuItem>
                    <MenuItem value={0}>NRI</MenuItem>
                  </TextField>
                )}
              />
              <FormHelperText>{errors.nationality?.message}</FormHelperText>
            </FormControl>
          </Box>
        </Grid>

        <Grid item xs={12} md={10}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={watch("enableMhCandidate")}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    setValue("enableMhCandidate", isChecked);
                    setValue("ismhcandidate", isChecked ? "" : null);
                  }}
                />
              }
              label="Enable State Domicile Candidate"
              sx={{ whiteSpace: "nowrap" }}
            />

            <FormControl
              fullWidth
              error={!!errors.ismhcandidate}
              disabled={!watch("enableMhCandidate")}
            >
              <Controller
                name="ismhcandidate"
                control={control}
                rules={{
                  required: watch("enableMhCandidate")
                    ? "Select State DomicileCandidate required"
                    : false,
                }}
                render={({ field }) => (
                  <TextField
                    select
                    label="Select State Domicile Candidate"
                    value={field.value ?? ""}
                    onChange={(e) => field.onChange(e.target.value)}
                    disabled={!watch("enableMhCandidate")}
                    sx={{ width: "100%" }}
                  >
                    <MenuItem value="" disabled>
                      Select One
                    </MenuItem>
                    <MenuItem value={1}>Yes</MenuItem>
                    <MenuItem value={0}>No</MenuItem>
                  </TextField>
                )}
              />
              <FormHelperText>{errors.ismhcandidate?.message}</FormHelperText>
            </FormControl>
          </Box>
        </Grid>

        <Grid item xs={12} md={10}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={watch("enableCategory")}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    setValue("enableCategory", isChecked);
                    if (!isChecked) {
                      setValue("categoryid", []);
                    }
                  }}
                />
              }
              label="Enable Category Selection"
              sx={{ whiteSpace: "nowrap" }}
            />

            <FormControl
              fullWidth
              error={!!errors.categoryid}
              disabled={!watch("enableCategory")}
              sx={{ marginLeft: "5%" }}
            >
              <Controller
                name="categoryid"
                control={control}
                rules={{
                  required: watch("enableCategory")
                    ? "Category required"
                    : false,
                }}
                defaultValue={[]}
                render={({ field }) => (
                  <TextField
                    select
                    fullWidth
                    label="Select Category"
                    SelectProps={{
                      multiple: true,
                      value: Array.isArray(field.value) ? field.value : [],
                      onChange: (e) => {
                        const selectedValues = Array.isArray(e.target.value)
                          ? e.target.value
                          : [e.target.value];
                        field.onChange(selectedValues);
                      },
                      renderValue: (selected) => (
                        <Box
                          sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                        >
                          {selected.map((value) => {
                            const selectedCategory = categoryList?.all?.find(
                              (cat) =>
                                parseInt(cat.categoryid) === parseInt(value)
                            );

                            return (
                              <Chip
                                key={value}
                                label={selectedCategory?.category || "Unknown"}
                              />
                            );
                          })}
                        </Box>
                      ),
                    }}
                    error={!!errors.categoryid}
                    sx={{ width: "100%" }}
                    disabled={!watch("enableCategory")}
                  >
                    <MenuItem key="" value="" disabled>
                      Select Category
                    </MenuItem>
                    {categoryList?.all?.map((obj) => (
                      <MenuItem
                        key={obj.categoryid?.toString()}
                        value={obj.categoryid?.toString()}
                      >
                        {obj.category}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
              <FormHelperText>{errors.categoryid?.message}</FormHelperText>
            </FormControl>
          </Box>
          <FormHelperText style={{ margin: 0, color: "#d32f2f" }}>
            {errors?.categoryid?.message}
          </FormHelperText>
        </Grid>

        <Grid item xs={12} md={10}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={watch("enableOrphan")}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    setValue("enableOrphan", isChecked);
                    setValue("isorphan", isChecked ? "" : null);
                  }}
                />
              }
              label="Enable Orphan Selection"
              sx={{ whiteSpace: "nowrap" }}
            />

            <FormControl
              fullWidth
              error={!!errors.isorphan}
              sx={{ marginLeft: "6%" }}
            >
              <Controller
                name="isorphan"
                control={control}
                rules={{
                  required: watch("enableOrphan")
                    ? "Select is Orphan required"
                    : false,
                }}
                render={({ field }) => (
                  <TextField
                    select
                    fullWidth
                    label="Select Is Orphan"
                    SelectProps={{
                      value: field.value ?? "",
                      onChange: (e) => field.onChange(e.target.value),
                    }}
                    error={!!errors.isorphan}
                    disabled={!watch("enableOrphan")}
                    sx={{ width: "100%" }}
                  >
                    <MenuItem value="" disabled>
                      Select One
                    </MenuItem>
                    <MenuItem value={1}>Yes</MenuItem>
                    <MenuItem value={0}>No</MenuItem>
                  </TextField>
                )}
              />
              <FormHelperText>{errors.isorphan?.message}</FormHelperText>
            </FormControl>
          </Box>
        </Grid>

        <Grid item xs={12} md={10}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={watch("enableDisability")}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    setValue("enableDisability", isChecked);
                    if (!isChecked) {
                      setValue("disabilitytypeid", []);
                    }
                  }}
                />
              }
              label="Enable Disability Selection"
              sx={{ whiteSpace: "nowrap" }}
            />

            <FormControl
              fullWidth
              error={!!errors.pwdtypeid}
              disabled={!watch("enableDisability")}
              sx={{ marginLeft: "5%" }}
            >
              <Controller
                name="disabilitytypeid"
                control={control}
                rules={{
                  required: watch("enableDisability")
                    ? "Disability required"
                    : false,
                }}
                defaultValue={[]}
                render={({ field }) => (
                  <TextField
                    select
                    fullWidth
                    label="Select Disability"
                    SelectProps={{
                      multiple: true,
                      value: Array.isArray(field.value) ? field.value : [],
                      onChange: (e) => {
                        const selectedValues = Array.isArray(e.target.value)
                          ? e.target.value
                          : [e.target.value];
                        field.onChange(selectedValues);
                      },
                      renderValue: (selected) => (
                        <Box
                          sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                        >
                          {selected.map((value) => {
                            const selectedDisability = pwdtypeList?.all?.find(
                              (item) =>
                                parseInt(item.pwdtypeid) === parseInt(value)
                            );
                            return (
                              <Chip
                                key={value}
                                label={selectedDisability?.pwdtype || "Unknown"}
                              />
                            );
                          })}
                        </Box>
                      ),
                    }}
                    error={!!errors.pwdtypeid}
                    disabled={!watch("enableDisability")}
                  >
                    <MenuItem key="" value="" disabled>
                      Select Disability Type
                    </MenuItem>

                    {pwdtypeList?.all?.map((obj) => (
                      <MenuItem
                        key={obj.pwdtypeid?.toString()}
                        value={obj.pwdtypeid?.toString()}
                      >
                        {obj.pwdtype}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </FormControl>
          </Box>
          <FormHelperText style={{ margin: 0, color: "#d32f2f" }}>
            {errors?.pwdtypeid?.message}
          </FormHelperText>
        </Grid>

        {watch("criteria_option") == 1 && (
          <>
            <Grid item xs={12} md={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={watch("enableHSC")}
                    onChange={(e) => {
                      const isChecked = e.target.checked;

                      setValue("enableHSC", isChecked);
                      if (!isChecked) {
                        setValue("hscpercentage", "");
                        setValue("hscyearofpassing", "");
                        setValue("hscminage", "");
                        setValue("hscmaxage", "");
                        setValue("hscason", null);
                      }
                    }}
                  />
                }
                label="HSC"
                sx={{ whiteSpace: "nowrap" }}
              />
            </Grid>

            {/* percentage */}
            <Grid item xs={12} md={6}>
              <TextField
                {...register("hscpercentage", {
                  // required: watch("enableHSC") ? "percentage is required" : false,
                  validate: (value) => {
                    return value
                      ? /^\d+$/.test(value) || "percentage must be numeric"
                      : true;
                  },
                })}
                InputLabelProps={{
                  shrink: !!watch("hscpercentage"),
                }}
                error={!!errors.hscpercentage}
                helperText={errors.hscpercentage?.message}
                FormHelperTextProps={{
                  style: { margin: 0 },
                }}
                size="small"
                fullWidth
                disabled={!watch("enableHSC")}
                label={<span>percentage</span>}
                onChange={(e) => {
                  const value = e.target.value;
                  setValue("hscpercentage", value);
                }}
              />
            </Grid>

            {/* Year of Passing */}
            <Grid item xs={12} md={6}>
              <FormControl
                fullWidth
                error={!!errors.hscyearofpassing}
                disabled={!watch("enableHSC")}
              >
                <Controller
                  name="hscyearofpassing"
                  control={control}
                  // rules={{
                  //   required: watch("enableHSC")
                  //     ? "Year of passing is required"
                  //     : false,
                  // }}
                  defaultValue=""
                  render={({ field }) => (
                    <TextField
                      select
                      fullWidth
                      label="Passing Year Should be Greater then or Equal to"
                      size="small"
                      value={field.value}
                      onChange={(e) => field.onChange(e.target.value)}
                      error={!!errors.hscyearofpassing}
                      helperText={errors.hscyearofpassing?.message}
                      disabled={!watch("enableHSC")}
                    >
                      <MenuItem value="" disabled>
                        Select One
                      </MenuItem>
                      {years.map((year) => (
                        <MenuItem key={year} value={year}>
                          {year}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                />
              </FormControl>
            </Grid>

            {/* Minimum Age */}
            <Grid item xs={12} md={6}>
              <TextField
                {...register("hscminage", {
                  // required: watch("enableHSC") ? "Minimum Age required" : false,
                  validate: (value) => {
                    return value
                      ? /^\d+$/.test(value) || "Minimum Age must be numeric"
                      : true;
                  },
                })}
                InputLabelProps={{
                  shrink: !!watch("hscminage"),
                }}
                error={!!errors.hscminage}
                helperText={errors.hscminage?.message}
                FormHelperTextProps={{
                  style: { margin: 0 },
                }}
                size="small"
                fullWidth
                disabled={!watch("enableHSC")}
                label={<span>Minimum Age</span>}
                onChange={(e) => {
                  const value = e.target.value;
                  setValue("hscminage", value);
                }}
              />
            </Grid>

            {/* Maximum Age */}
            <Grid item xs={12} md={6}>
              <TextField
                {...register("hscmaxage", {
                  // required: watch("enableHSC") ? "Maximum Age required" : false,
                  validate: (value) => {
                    return value
                      ? /^\d+$/.test(value) || "Maximum Age must be numeric"
                      : true;
                  },
                })}
                InputLabelProps={{
                  shrink: !!watch("hscmaxage"),
                }}
                error={!!errors.hscmaxage}
                helperText={errors.hscmaxage?.message}
                FormHelperTextProps={{
                  style: { margin: 0 },
                }}
                size="small"
                fullWidth
                disabled={!watch("enableHSC")}
                label={<span>Maximum Age</span>}
                onChange={(e) => {
                  const value = e.target.value;
                  setValue("hscmaxage", value);
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Controller
                name="hscason"
                control={control}
                // rules={{
                //   required: watch("enableHSC") ? "AS On date is required" : false,
                // }}
                render={({ field }) => (
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      {...field}
                      label={<span>AS On Date</span>}
                      format="DD/MM/YYYY"
                      onChange={(date) => field.onChange(date)}
                      disabled={!watch("enableHSC")}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          readOnly: true,
                          size: "small",
                          error: !!errors.hscason,
                          helperText: errors.hscason?.message,
                          FormHelperTextProps: {
                            style: { margin: 0 },
                          },
                          style: {
                            width: "100%",
                            borderRadius: "8px",
                          },
                        },
                        layout: {
                          sx: {
                            borderRadius: "58px",
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>
                )}
              />
            </Grid>

            <Grid item xs={12} md={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={watch("enableUG")}
                    onChange={(e) => {
                      setValue("enableUG", e.target.checked);
                      if (e.target.checked === false) {
                        setValue("ugpercentage", "");
                        setValue("ugyearofpassing", "");
                        setValue("ugminage", "");
                        setValue("ugmaxage", "");
                        setValue("ugason", null);
                        setValue("compulsorysubject", []);
                      }
                    }}
                  />
                }
                label="UG"
                sx={{ whiteSpace: "nowrap" }}
              />
            </Grid>

            {/* percentage */}
            <Grid item xs={12} md={6}>
              <TextField
                {...register("ugpercentage", {
                  // required: watch("enableUG") ? "percentage is required" : false,
                  validate: (value) => {
                    return value
                      ? /^\d+$/.test(value) || "percentage must be numeric"
                      : true;
                  },
                })}
                InputLabelProps={{
                  shrink: !!watch("ugpercentage"),
                }}
                error={!!errors.ugpercentage}
                helperText={errors.ugpercentage?.message}
                FormHelperTextProps={{
                  style: { margin: 0 },
                }}
                size="small"
                fullWidth
                disabled={!watch("enableUG")}
                label={<span>percentage</span>}
                onChange={(e) => {
                  const value = e.target.value;
                  setValue("ugpercentage", value);
                }}
              />
            </Grid>

            {/* Year of Passing */}
            <Grid item xs={12} md={6}>
              <FormControl
                fullWidth
                error={!!errors.ugyearofpassing}
                disabled={!watch("enableUG")}
              >
                <Controller
                  name="ugyearofpassing"
                  control={control}
                  // rules={{
                  //   required: watch("enableUG")
                  //     ? "Year of passing is required"
                  //     : false,
                  // }}
                  defaultValue=""
                  render={({ field }) => (
                    <TextField
                      select
                      fullWidth
                      label="Passing Year Should be Greater then or Equal to "
                      size="small"
                      value={field.value}
                      onChange={(e) => field.onChange(e.target.value)}
                      error={!!errors.ugyearofpassing}
                      helperText={errors.ugyearofpassing?.message}
                      disabled={!watch("enableUG")}
                    >
                      <MenuItem value="" disabled>
                        Select One
                      </MenuItem>
                      {years.map((year) => (
                        <MenuItem key={year} value={year}>
                          {year}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                />
              </FormControl>
            </Grid>

            {/* Minimum Age */}
            <Grid item xs={12} md={6}>
              <TextField
                {...register("ugminage", {
                  // required: watch("enableUG") ? "Minimum Age required" : false,
                  validate: (value) => {
                    return value
                      ? /^\d+$/.test(value) || "Minimum Age must be numeric"
                      : true;
                  },
                })}
                InputLabelProps={{
                  shrink: !!watch("ugminage"),
                }}
                error={!!errors.ugminage}
                helperText={errors.ugminage?.message}
                FormHelperTextProps={{
                  style: { margin: 0 },
                }}
                size="small"
                fullWidth
                disabled={!watch("enableUG")}
                label={<span>Minimum Age</span>}
                onChange={(e) => {
                  const value = e.target.value;
                  setValue("ugminage", value);
                }}
              />
            </Grid>

            {/* Maximum Age */}
            <Grid item xs={12} md={6}>
              <TextField
                {...register("ugmaxage", {
                  // required: watch("enableUG") ? "Maximum Age required" : false,
                  validate: (value) => {
                    return value
                      ? /^\d+$/.test(value) || "Maximum Age must be numeric"
                      : true;
                  },
                })}
                InputLabelProps={{
                  shrink: !!watch("ugmaxage"),
                }}
                error={!!errors.ugmaxage}
                helperText={errors.ugmaxage?.message}
                FormHelperTextProps={{
                  style: { margin: 0 },
                }}
                size="small"
                fullWidth
                disabled={!watch("enableUG")}
                label={<span>Maximum Age</span>}
                onChange={(e) => {
                  const value = e.target.value;
                  setValue("ugmaxage", value);
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Controller
                name="ugason"
                control={control}
                // rules={{
                //   required: watch("enableUG") ? "AS On date is required" : false,
                // }}
                render={({ field }) => (
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      {...field}
                      label={<span>AS On Date</span>}
                      format="DD/MM/YYYY"
                      onChange={(date) => field.onChange(date)}
                      disabled={!watch("enableUG")}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          readOnly: true,
                          size: "small",
                          error: !!errors.ugason,
                          helperText: errors.ugason?.message,
                          FormHelperTextProps: {
                            style: { margin: 0 },
                          },
                          style: {
                            width: "100%",
                            borderRadius: "8px",
                          },
                        },
                        layout: {
                          sx: {
                            borderRadius: "58px",
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>
                )}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <FormControl
                  fullWidth
                  error={!!errors.compulsorysubject}
                  disabled={!watch("enableUG")}
                >
                  <Controller
                    name="compulsorysubject"
                    control={control}
                    defaultValue={[]}
                    rules={{
                      required: watch("enableUG")
                        ? "Compulsory subject required"
                        : false,
                    }}
                    render={({ field }) => (
                      <TextField
                        select
                        label="Select Compulsory Subject"
                        size="small"
                        fullWidth
                        SelectProps={{
                          multiple: true,
                          value: Array.isArray(field.value)
                            ? field.value.map(String)
                            : [],
                          onChange: (e) => {
                            const selectedValues = Array.isArray(e.target.value)
                              ? e.target.value
                              : [e.target.value];
                            field.onChange(selectedValues);
                          },
                          renderValue: (selected) => (
                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 0.5,
                              }}
                            >
                              {selected.map((value) => {
                                const selectedSubject =
                                  gspecializationSubjectList?.all?.find(
                                    (sub) =>
                                      String(sub.gspecializationid) ===
                                      String(value)
                                  );
                                return (
                                  <Chip
                                    key={value}
                                    label={
                                      selectedSubject?.gspecializaiton ||
                                      "Unknown"
                                    }
                                  />
                                );
                              })}
                            </Box>
                          ),
                        }}
                      >
                        <MenuItem key="" value="" disabled>
                          Select Compulsory Subject
                        </MenuItem>
                        {gspecializationSubjectList?.all?.map((obj) => (
                          <MenuItem
                            key={obj.gspecializationid}
                            value={String(obj.gspecializationid)}
                          >
                            {obj.gspecializaiton}
                          </MenuItem>
                        ))}
                      </TextField>
                    )}
                  />
                </FormControl>
              </Box>

              <FormHelperText style={{ margin: 0, color: "#d32f2f" }}>
                {errors?.compulsorysubject?.message}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} md={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={watch("enablePG")}
                    onChange={(e) => {
                      setValue("enablePG", e.target.checked);
                      if (e.target.checked === false) {
                        setValue("pgpercentage", "");
                        setValue("pgyearofpassing", "");
                        setValue("pgminage", "");
                        setValue("pgmaxage", "");
                        setValue("pgason", null);
                      }
                    }}
                  />
                }
                label="PG"
                sx={{ whiteSpace: "nowrap" }}
              />
            </Grid>

            {/* percentage */}
            <Grid item xs={12} md={6}>
              <TextField
                {...register("pgpercentage", {
                  // required: watch("enablePG") ? "percentage is required" : false,
                  validate: (value) => {
                    return value
                      ? /^\d+$/.test(value) || "percentage must be numeric"
                      : true;
                  },
                })}
                InputLabelProps={{
                  shrink: !!watch("pgpercentage"),
                }}
                error={!!errors.pgpercentage}
                helperText={errors.pgpercentage?.message}
                FormHelperTextProps={{
                  style: { margin: 0 },
                }}
                size="small"
                fullWidth
                disabled={!watch("enablePG")}
                label={<span>percentage</span>}
                onChange={(e) => {
                  const value = e.target.value;
                  setValue("pgpercentage", value);
                }}
              />
            </Grid>

            {/* Year of Passing */}
            <Grid item xs={12} md={6}>
              <FormControl
                fullWidth
                error={!!errors.pgyearofpassing}
                disabled={!watch("enablePG")}
              >
                <Controller
                  name="pgyearofpassing"
                  control={control}
                  // rules={{
                  //   required: watch("enablePG")
                  //     ? "Year of passing is required"
                  //     : false,
                  // }}
                  defaultValue=""
                  render={({ field }) => (
                    <TextField
                      select
                      fullWidth
                      label="Passing Year Should be Greater then or Equal to "
                      size="small"
                      value={field.value}
                      onChange={(e) => field.onChange(e.target.value)}
                      error={!!errors.pgyearofpassing}
                      helperText={errors.pgyearofpassing?.message}
                      disabled={!watch("enablePG")}
                    >
                      <MenuItem value="" disabled>
                        Select One
                      </MenuItem>
                      {years.map((year) => (
                        <MenuItem key={year} value={year}>
                          {year}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                />
              </FormControl>
            </Grid>

            {/* Minimum Age */}
            <Grid item xs={12} md={6}>
              <TextField
                {...register("pgminage", {
                  // required: watch("enablePG") ? "Minimum Age required" : false,
                  validate: (value) => {
                    return value
                      ? /^\d+$/.test(value) || "Minimum Age must be numeric"
                      : true;
                  },
                })}
                InputLabelProps={{
                  shrink: !!watch("pgminage"),
                }}
                error={!!errors.pgminage}
                helperText={errors.pgminage?.message}
                FormHelperTextProps={{
                  style: { margin: 0 },
                }}
                size="small"
                fullWidth
                disabled={!watch("enablePG")}
                label={<span>Minimum Age</span>}
                onChange={(e) => {
                  const value = e.target.value;
                  setValue("pgminage", value);
                }}
              />
            </Grid>

            {/* Maximum Age */}
            <Grid item xs={12} md={6}>
              <TextField
                {...register("pgmaxage", {
                  // required: watch("enablePG") ? "Maximum Age required" : false,
                  validate: (value) => {
                    return value
                      ? /^\d+$/.test(value) || "Maximum Age must be numeric"
                      : true;
                  },
                })}
                InputLabelProps={{
                  shrink: !!watch("pgmaxage"),
                }}
                error={!!errors.pgmaxage}
                helperText={errors.pgmaxage?.message}
                FormHelperTextProps={{
                  style: { margin: 0 },
                }}
                size="small"
                fullWidth
                disabled={!watch("enablePG")}
                label={<span>Maximum Age</span>}
                onChange={(e) => {
                  const value = e.target.value;
                  setValue("pgmaxage", value);
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Controller
                name="pgason"
                control={control}
                // rules={{
                //   required: watch("enablePG") ? "AS On date is required" : false,
                // }}
                render={({ field }) => (
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      {...field}
                      label={<span>AS On Date</span>}
                      format="DD/MM/YYYY"
                      onChange={(date) => field.onChange(date)}
                      disabled={!watch("enablePG")}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          readOnly: true,
                          size: "small",
                          error: !!errors.pgason,
                          helperText: errors.pgason?.message,
                          FormHelperTextProps: {
                            style: { margin: 0 },
                          },
                          style: {
                            width: "100%",
                            borderRadius: "8px",
                          },
                        },
                        layout: {
                          sx: {
                            borderRadius: "58px",
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>
                )}
              />
            </Grid>
          </>
        )}
      </Grid>

      <Grid
        item
        md={12}
        sx={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}
      >
        <BackButton
          handleBack={() =>
            navigate(
              `/${Cookies.get(
                "mhet_mst_project"
              )}/eligibility-management?page=eligibilitycriteria`
            )
          }
        />
        <BluePrimaryButton
          handleSubmit={handleSubmit(
            location.search !== "?page=updateeligibility"
              ? handleAddEligibility
              : handleUpdateEligibility
          )}
          title={
            location.search === "?page=updateeligibility" ? "Update" : "Submit"
          }
        />
      </Grid>
      <CreateMasterModal
        // trigger={trigger}
        getValues={getValues}
        register={register}
        // handleSubmit={handleSubmit}
        errors={errors}
        resetForm={resetForm}
        watch={watch}
      />
    </>
  );
}
